import { RateBase } from "@Light/services/lightTypes";

export function isMatchedSolarBuyback(
  plan: Pick<
    RateBase,
    | "has_solar_buyback"
    | "export_rate_cents_per_kwh"
    | "energy_rate_cents_per_kwh"
  >,
): boolean {
  const {
    has_solar_buyback,
    export_rate_cents_per_kwh,
    energy_rate_cents_per_kwh,
  } = plan;

  return (
    has_solar_buyback && export_rate_cents_per_kwh === energy_rate_cents_per_kwh
  );
}
